import Service, { service } from '@ember/service';

import { apiBaseURL, apiNamespace } from 'register-partners-js/constants/hosts';

export default class PricingService extends Service {
  @service networkManager;

  async fetchPricePlans(legalCountry) {
    let pricePlans;

    let url = `${apiBaseURL}/${apiNamespace}/price_plan_offers/register_existing_company?legal_country=${legalCountry}`;
    let response = await this.networkManager.request(url);
    pricePlans = response.price_plans;

    return pricePlans;
  }

  async fetchPricePlansForCompanyCreation(legalCountry) {
    let url = `${apiBaseURL}/${apiNamespace}/price_plan_offers/register_company_creation?legal_country=${legalCountry}`;
    let response = await this.networkManager.request(url);
    return response.price_plans;
  }

  async fetchOrderForCompanyCreation({ legalCountry, pricePlanCode, recurrence }) {
    let url = `${apiBaseURL}/${apiNamespace}/price_plan_offers/${pricePlanCode}/estimate_company_creation?legal_country=${legalCountry}&recurrence=${recurrence}`;
    return await this.networkManager.request(url);
  }
}
